import { arrayContainsValues } from '@shared/core/types/common';

const imageFileExtensionsCards = ['jpeg', 'jpg', 'png'] as const;

export const imageFileExtensionsCardsType = arrayContainsValues(...imageFileExtensionsCards);
